module.exports = __webpack_public_path__ + "img/day1.da3f974a.jpg";